const tooltipContent = {
	nameAndType: {
		title: 'Add name and select type of alert',
		desc: 'Add a unique name and select the type of alert',
		hasHotSpot: false,
	},
	metric: {
		title: 'Select the metric',
		desc: 'Select metric from the list for which you want to add an alert. All the selections below are mandatory to create an alert',
		hasHotSpot: true,
	},
	addStore: {
		title: 'Add Stores',
		desc: 'Add specific stores to narrow down the results for your alert',
		hasHotSpot: true,
	},
	searchStore: {
		title: 'Search store or Paste a list of store',
		desc: 'Start typing the store # and select from the list. OR if you have a list use “Paste Store #” to paste the list',
		hasHotSpot: false,
	},
	addItem: {
		title: 'Add Items/Departments/Categories',
		desc: 'Add specific items/departments/categories to narrow down the results for your rule',
		hasHotSpot: false,
	},
	searchItem: {
		title: 'Search item or Paste a list of items',
		desc: 'Start typing the item # /name and select from the list. OR if you have a list use “Paste item #” to paste the list',
		hasHotSpot: false,
	},
	previewAlert: {
		title: 'Preview Alert',
		desc: 'Preview all the selections made before you commit',
		hasHotSpot: true,
	},
	allSet: {
		title: 'You are all set',
		desc: 'You are done making all the selection. You can find all your alerts in your profile page',
		hasHotSpot: false,
	},
};

export default tooltipContent;
